export default __webpack_public_path__ + "static/media/Training_Quality_Seal_logo.2020.61558e0e.png";